import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const PLAN_LABEL = { monthly: "Monthly", semiannual: "6-Month", yearly: "Yearly" };

export const PlanBadge = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  if (!user) return null;

  const now = new Date();
  const subEnd = user.subscription_ends_at ? new Date(user.subscription_ends_at) : null;
  const trialEnd = user.trial_ends_at ? new Date(user.trial_ends_at) : null;
  const isPremium = user.subscription_status === "active" && subEnd && subEnd > now;
  const isTrial = !isPremium && trialEnd && trialEnd > now;
  const fmt = (d) => d.toLocaleDateString("en-GB");

  if (isPremium) {
    return (
      <div className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 mt-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-[#0F2744] to-[#1E3A5F] text-white text-xs font-semibold" data-testid="plan-badge">
        <Crown className="h-3.5 w-3.5 text-[#FFB020]" />
        <span data-testid="plan-badge-plan">ClassMate Premium · {PLAN_LABEL[user.subscription_plan] || user.subscription_plan || "Member"}</span>
        <span className="px-1.5 py-0.5 rounded-full bg-green-500/20 text-green-300" data-testid="plan-badge-status">Active</span>
        <span className="text-blue-200" data-testid="plan-badge-renewal">Renews {fmt(subEnd)}</span>
        <button onClick={() => navigate("/pricing")} className="text-[#7EB2FF] underline underline-offset-2" data-testid="plan-badge-extend-btn">Extend / Upgrade</button>
      </div>
    );
  }

  if (isTrial) {
    return (
      <div className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 mt-2 px-3 py-1.5 rounded-full border border-[#2563EB]/30 bg-[#2563EB]/5 text-xs font-semibold text-[#1E3A5F] dark:text-blue-200" data-testid="plan-badge">
        <Clock className="h-3.5 w-3.5 text-[#2563EB]" />
        <span data-testid="plan-badge-status">Free Trial</span>
        <span className="text-slate-500 dark:text-slate-400" data-testid="plan-badge-renewal">ends {fmt(trialEnd)}</span>
        <button onClick={() => navigate("/pricing")} className="text-[#2563EB] underline underline-offset-2" data-testid="plan-badge-upgrade-btn">Upgrade</button>
      </div>
    );
  }

  return (
    <div className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 mt-2 px-3 py-1.5 rounded-full border border-slate-200 dark:border-slate-700 text-xs font-semibold text-slate-600 dark:text-slate-300" data-testid="plan-badge">
      <span data-testid="plan-badge-status">Free plan</span>
      <button onClick={() => navigate("/pricing")} className="text-[#2563EB] underline underline-offset-2" data-testid="plan-badge-upgrade-btn">Go Premium</button>
    </div>
  );
};
